<template>
  <section class="hero-stack wf-section">
    <div class="container-7">
      <!-- <div v-if="loading" class="hero-wrapper-two custom-loader-wrapper">
        <div v-if="NotFound">
          <h1 style="margin: 0">No Article Found</h1>
        </div>
        <div v-else class="custom-loader"></div>
      </div> -->
      <div class="hero-wrapper-two">
        <h1 class="centered-heading">
          <span class="highlightheading">Who</span> is Dr. Aafia Siddiqui?
        </h1>
        <div class="newscontent">
          <!-- <h2 class="general-h2"></h2> -->
          <div v-html="highlightText(contentText, $store.state.searchQuery)">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "WhoIsDrAafia",
  data() {
    return {
      obj: {},
      loading: false,
      NotFound: false,
      contentText: `Dr. Aafia Siddiqui is a Pakistani educationist, a graduate of the
            prestigious Massachusetts Institute of Technology (MIT), and a PhD
            holder from Brandeis University. Once celebrated for her academic
            brilliance and commitment to humanitarian causes, she is now one of
            the most high-profile cases of injustice in recent global history.
            <br /><br />
            Born in Karachi, Pakistan, Aafia moved to the United States in the
            early 1990s to pursue higher education. She excelled in her studies
            and was known for her dedication to Islam, community work, and
            passion for early childhood education. <br /><br />
            In March 2003, Dr. Aafia Siddiqui and her three young children were
            abducted from Karachi in what human rights organizations have
            described as a forced disappearance. Her children were dealt with in
            the following manner: <br /><br />
            <ul>
              <li>
                Suleman, just six months old, was allegedly murdered during the
                abduction.
              </li>
              <li>
                Maryam, Aafia's three-year-old daughter, was forcibly adopted
                and raised under a different faith.
              </li>
              <li>
                Ahmed, Aafia's eldest child and at only 6-years-old, was
                imprisoned for years before finally being reunited with his
                family.
              </li>
            </ul>
            From 2003-2008, Dr. Aafia was held in secret prisons, including the
            notorious Bagram – U.S. Air Base, where she endured unimaginable
            acts of violence. <br /><br />
            After years of secret confinement, Aafia reappeared in the summer of
            2008, yet was taken into custody again. This time, for baseless
            charges related to an incident that took place on July 18, 2008,
            when she allegedly attempted to shoot at U.S. personnel. During the
            alleged exchange, Aafia was the only person shot— not once but
            twice. The U.S., without any legal jurisdiction, shot and flew
            Aafia, a Pakistani citizen, from Afghanistan to America without any
            extradition proceedings. <br /><br />
            What followed was a deeply flawed and controversial legal process.
            Despite a complete lack of forensic evidence, no credible witness
            testimony, and a blatant disregard for due process, Aafia was
            convicted and sentenced to 86 years in U.S. federal prison.
            <br /><br />
            Dr. Aafia is currently imprisoned at FMC Carswell, the only federal
            medical prison for women in the United States, notoriously known as
            the <b>"Hospital of Horrors."</b> Numerous reports have raised
            concerns about her physical and mental health, and independent human
            rights lawyers have labeled her detention as illegal under both U.S.
            and international law. <br /><br />`,
    };
  },
  methods: {
    highlightText(text, query) {
      if (!text || !query || !query.trim()) {
        return text || '';
      }
      
      const searchQuery = query.trim();
      const escapedQuery = this.escapeRegex(searchQuery);
      const regex = new RegExp(`(${escapedQuery})`, 'gi');
      
      // Handle HTML content - find text nodes and highlight them
      return text.replace(/>([^<]+)</g, (match, textContent) => {
        const highlighted = textContent.replace(regex, '<mark class="search-highlight">$1</mark>');
        return `>${highlighted}<`;
      });
    },
    escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
  },
};
</script>
<style scoped>
/* Search highlight styling */
:deep(.search-highlight) {
  background-color: #198754;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(25, 135, 84, 0.3);
  display: inline-block;
}
</style>
